import supabase from './supabase'
import db from './db'

export default {
    supabase,
    db,
}